import * as React from 'react';
import { useSelector } from '../redux/store';
import { getCommonErrors } from '../redux/notification/notificationsSelectors';

export const NotificationsArea: React.FC = () => {
  const items = useSelector(getCommonErrors);

  return (
    <>
      {items.length ? (
        <div className="text-red-500 justify-center content-center">
          {items.map((item) => (
            <p className="text-center" key={item.error}>
              {item.error}
            </p>
          ))}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
